import { createSvgIcon } from 'common/theme/utils';

import Sort from './Sort.svg?react';

export const SortIcon = createSvgIcon(Sort, 'Sort');
